import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=33fd2b5a&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports